import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'react-emotion';
import { Icon } from 'web-ui-components/lib/atoms/iconography';
import { UnfinishedWorkModal } from 'web-ui-components/lib/organisms/modals';
import { Button } from 'web-ui-components/lib/atoms/buttons';

import deleteTemplateContent from './deleteTemplate.content';
import withContent from '../../containers/withContent';

const StyledDeleteTemplateContainer = styled('div')`
	@media (min-width: 767px) {
		.delete-template-button {
			span.c-a-button__title {
				min-width: 110px;
			}
		}
	}
	@media (max-width: 766px) {
		.delete-template-button {
			span.c-a-button__title {
				display: none;
			}
		}
	}
`;

class DeleteTemplate extends Component {
	constructor(props) {
		super(props);

		this.state = { deleteTemplateModalIsOpen: false };
	}

	render() {
		const { handleDeleteTemplate, content } = this.props;
		const {
			deleteTemplateModalDestructiveActionButton,
			deleteTemplateModalTitle,
			deleteTemplateModalSubText,
			deleteTemplateModalSafeActionButton,
			deleteButtonText,
		} = content;
		return (
			<StyledDeleteTemplateContainer>
				<Button
					id="delete-template-button"
					width="flush"
					display="secondary"
					onClick={() => this.setState({ deleteTemplateModalIsOpen: true })}
					className="delete-template-button"
				>
					<Icon size="sm" iconType="TrashLarge" className="c-a-button__icon" />
					{deleteButtonText}
				</Button>

				<UnfinishedWorkModal
					destructiveActionButtonText={deleteTemplateModalDestructiveActionButton}
					isOpen={this.state.deleteTemplateModalIsOpen}
					onClose={() => this.setState({ deleteTemplateModalIsOpen: false })}
					onDestructiveAction={handleDeleteTemplate}
					safeActionButtonText={deleteTemplateModalSafeActionButton}
					titleText={deleteTemplateModalTitle}
				>
					<p>{deleteTemplateModalSubText}</p>
				</UnfinishedWorkModal>
			</StyledDeleteTemplateContainer>
		);
	}
}

DeleteTemplate.propTypes = {
	handleDeleteTemplate: PropTypes.func,
	content: PropTypes.shape({}),
};

export default withContent({ content: deleteTemplateContent })(DeleteTemplate);
